import { EConditionType } from '../../../../json_query';
import { IBuildingConditionsTag } from '../../../state/tags/definitions/building_condition';
import { getMultiSelectionParamTagItem } from './fabrics/multi_selection_param_tag';

const buildingConditionMap = {
  [EConditionType.RegularRepair]: 'Типовой ремонт',
  [EConditionType.DesignerRepair]: 'Дизайнерский ремонт',
  [EConditionType.FullDecorationNeeded]: 'Под чистовую отделку',
  [EConditionType.MajorRepairNeeded]: 'Требуется капитальный ремонт',
  [EConditionType.CosmeticRepairNeeded]: 'Требуется косметический ремонт',
};

export const BuildingConditionTypesTagItem = getMultiSelectionParamTagItem<EConditionType, IBuildingConditionsTag>(
  buildingConditionMap,
);
